import { TreeProtectedEntity } from '../../../helpers/types';
import { DeleteEntityActionValidator } from '../specifics/delete.entity.action.validator';
import { ProtectedEntitiesHelper } from '../../../helpers/protectedEntities/protected.entities.helper';

export class DeleteFromTreeActionValidator extends DeleteEntityActionValidator {
  protected _canPerformAction(record: TreeProtectedEntity): boolean {
    const isServiceTarget = this.isRecordInTargets(record);
    return ProtectedEntitiesHelper.isEditableFolder(record) && !isServiceTarget;
  }
}
